function displayCent(centValue = 0) {
  const euro = Math.floor(centValue / 100)
  const cent = centValue % 100
  const centWithZero = String(cent).padStart(2, "0")
  if (centValue > 0) {
    return `${euro},${centWithZero} €`
  } else {
    return `0,00 €`
  }
}
function displayPrice(centValue = 0) {
  const euro = centValue / 100
  return euro
}
export { displayCent }
export { displayPrice }
